var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow flex-1 flex items-center"},[_c('gd-dropdown',{staticClass:"text-white",attrs:{"options":_vm.options,"styled":"font-family","size":"full","variant":"dark"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }